module.exports = __webpack_public_path__ + "2cc6acb4208441c01573ce05ce6e5935.png";